import React, { useState} from "react";
import {
  Input,
  MenuItem,
  Button,
  Paper,
  InputLabel,
  FormControl,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";

import { useUserContext } from "../../../../../context/UserContext";

import { firestore, Timestamp} from '../../../../../firebase';

// styles
import useStyles from "./styles";

// components
import Widget from "../../../../../components/Widget";
import { Typography } from "../../../../../components/Wrappers";

export default function Survey(props) {
  var classes = useStyles();
  var profile = useUserContext().userInformation;
  var setProfile = useUserContext().setUserInformation;

  const industryList = [
    { label: 'Retail', value: 'retail' },
    { label: 'Industrial/Manufacturing', value: 'Industrial/Manufacturing' },
    { label: 'Agricultural/Food', value: 'Agricultural/Food' },
    { label: 'Healthcare', value: 'Healthcare' },
    { label: 'Financial Services', value: 'Financial Services' },
    { label: 'Natural Resources/Energy', value: 'Natural Resources/Energy' },
    { label: 'Telecommunications', value: 'Telecommunications' },
    { label: 'Higher Education', value: 'Higher Education' },
    { label: 'Government', value: 'Government' },
    { label: 'Price Equity', value: 'Price Equity' },
    { label: 'Non-Profit', value: 'Non-Profit' },
    { label: 'Professional Services', value: 'Professional Services' },
    { label: 'Information Technology', value: 'Information Technology' },
  ];

  const radio_props_agree_disagree = [
    {label: '1', value: 'Strongly Disagree (1)' },
    {label: '2', value: 'Somewhat Disagree (2)' },
    {label: '3', value: 'Neither Agree nor Disagree (3)' },
    {label: '4', value: 'Somewhat Agree (4)' },
    {label: '5', value: 'Strongly Agree (5)' }
  ];

  const radio_props_yes_no = [
    {label: 'Yes', value: 'Yes' },
    {label: 'No', value: 'No' }
  ];

  const [surveyForm, setSurveyForm] = useState({
    email:'',
    name:'',
    company:'',
    industry: '',
    phone:'',
    mission:'',
    potential:'',
    bestPractices:'',
    kpi:'',
    disposition:'',
    aggressive:'',
    nrv:'',
    erpSystem:'',
    breakoutFinancials:'',
    REModule:'',
    challenges:'',
  });

  const handleChange = (prop) => (event) => {
    setSurveyForm({ ...surveyForm, [prop]: event.target.value });
  };

  const addForm = (survey) => {
    firestore
        .collection('Users')
        .doc(localStorage.getItem('user_uid'))
        .update({
          survey,
          surveyCompleted:true,
        })
        .then(() =>{
          setProfile({...profile, survey: survey, surveyCompleted: true});
        });
  };

  const handleClick = () => {
    const {email, name, company, industry, phone, mission, potential, bestPractices, kpi, disposition, aggressive, nrv, erpSystem, breakoutFinancials, REModule, challenges,} = surveyForm;
    const survey = {
        email:email,
        name:name,
        company:company,
        industry:industry,
        phone:phone,
        mission:mission,
        potential:potential,
        bestPractices:bestPractices,
        kpi:kpi,
        disposition:disposition,
        aggressive:aggressive,
        nrv:nrv,
        erpSystem:erpSystem,
        breakoutFinancials:breakoutFinancials,
        REModule:REModule,
        challenges:challenges,
        completed: Timestamp,
    };
    addForm(survey);

    // fetch('https://api.formium.io/submit/60ca82060304f100014fcb70/creed-survey', {
    //   method: 'POST',
    //   headers: {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     email:email,
    //     name:name,
    //   })
    // });

  };

  return(
    <>
        <Widget
        title="Corp. RE Earnings Diagnostic - Questionnaire"
        subtitle="Must fill in all fields"
        upperTitle
        className={classes.card}
        bodyClass={classes.fullHeightBody}
        >
            <div className={classes.performanceLegendWrapperForm}>
                <div className={classes.legendElement}>
                        <div className={classes.formContainer}>
                            <div className={classes.formContainerHorizontal}>
                                <Paper elevation={3} className={classes.paper}>
                                    <FormControl>
                                        <InputLabel htmlFor="standard-adornment-password">Email Address</InputLabel>
                                        <Input id="standard-adornment-password" onChange={handleChange('email')} />
                                    </FormControl>
                                </Paper>
                                <Paper elevation={3} className={classes.paper}>
                                    <FormControl>
                                        <InputLabel htmlFor="standard-adornment-name">Name/Contact</InputLabel>
                                        <Input id="standard-adornment-name" onChange={handleChange('name')} />
                                    </FormControl>
                                </Paper>
                                <Paper elevation={3} className={classes.paper}>
                                    <FormControl>
                                        <InputLabel htmlFor="standard-adornment-company">Company</InputLabel>
                                        <Input id="standard-adornment-company" onChange={handleChange('company')} />
                                    </FormControl>
                                </Paper>
                            </div>
                            <div className={classes.formContainerHorizontal}>
                                <Paper elevation={3} className={classes.paper}>
                                    <FormControl>
                                        <TextField 
                                            htmlFor="standard-select-industry"
                                            select
                                            label="Sector/Industry"
                                            onChange={handleChange('industry')}
                                        >
                                            {industryList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </FormControl>
                                </Paper>
                                <Paper elevation={3} className={classes.paper}>
                                    <FormControl>
                                        <InputLabel htmlFor="standard-adornment-phone">Phone</InputLabel>
                                        <Input id="standard-adornment-phone" onChange={handleChange('phone')} />
                                    </FormControl>
                                </Paper>
                            </div>
                            <div className={classes.formContainerHorizontal}>
                                <Paper elevation={3} className={classes.paperRadioButtons}>
                                    <FormControl component="fieldset">
                                        <Typography className={classes.radioTypography}>The corporate RE function has a clearly defined mission of contributing earnings to the enterprise?</Typography>
                                        <RadioGroup row aria-label="mission" name="mission" onChange={handleChange('mission')} className={classes.radioGroup}>
                                            <Typography>Disagree</Typography>
                                            {radio_props_agree_disagree.map((option) => (
                                                <FormControlLabel
                                                value={option.value}
                                                control={<Radio color="primary" />}
                                                label={option.label}
                                                labelPlacement="top"
                                                />
                                            ))}
                                            <Typography>Agree</Typography>
                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                                <Paper elevation={3} className={classes.paperRadioButtons}>
                                    <FormControl component="fieldset">
                                        <Typography className={classes.radioTypography}>There is untapped potential in the Company's RE assets for cost savings and new earnings.</Typography>
                                        <RadioGroup row aria-label="potential" name="potential" onChange={handleChange('potential')} className={classes.radioGroup}>
                                            <Typography>Disagree</Typography>
                                            {radio_props_agree_disagree.map((option) => (
                                                <FormControlLabel
                                                value={option.value}
                                                control={<Radio color="primary" />}
                                                label={option.label}
                                                labelPlacement="top"
                                                />
                                            ))}
                                            <Typography>Agree</Typography>
                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                            </div>
                            <div className={classes.formContainerHorizontal}>
                                <Paper elevation={3} className={classes.paperRadioButtons}>
                                    <FormControl component="fieldset">
                                        <Typography className={classes.radioTypography}>The Company is operating at a "best practices" level with respect to cost reduction strategies for real estate operating expenses and space utilization.</Typography>
                                        <RadioGroup row aria-label="bestPractices" name="bestPractices" onChange={handleChange('bestPractices')} className={classes.radioGroup}>
                                            <Typography>Disagree</Typography>
                                            {radio_props_agree_disagree.map((option) => (
                                                <FormControlLabel
                                                value={option.value}
                                                control={<Radio color="primary" />}
                                                label={option.label}
                                                labelPlacement="top"
                                                />
                                            ))}
                                            <Typography>Agree</Typography>
                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                                <Paper elevation={3} className={classes.paperRadioButtons}>
                                    <FormControl component="fieldset">
                                        <Typography className={classes.radioTypography}>The Company has established Key Performance Indicator's ("KPI's") for measuring RE's contribution to the success of the enterprise.</Typography>
                                        <RadioGroup row aria-label="kpi" name="kpi" onChange={handleChange('kpi')} className={classes.radioGroup}>
                                            {radio_props_yes_no.map((option) => (
                                                <FormControlLabel
                                                value={option.value}
                                                control={<Radio color="primary" />}
                                                label={option.label}
                                                labelPlacement="top"
                                                />
                                            ))}
                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                            </div>
                            <div className={classes.formContainerHorizontal}>
                                <Paper elevation={3} className={classes.paperRadioButtons}>
                                    <FormControl component="fieldset">
                                        <Typography className={classes.radioTypography}>The Company has a proactive strategy for disposition of excess property and leased space.</Typography>
                                        <RadioGroup row aria-label="disposition" name="disposition" onChange={handleChange('disposition')} className={classes.radioGroup}>
                                            <Typography>Disagree</Typography>
                                            {radio_props_agree_disagree.map((option) => (
                                                <FormControlLabel
                                                value={option.value}
                                                control={<Radio color="primary" />}
                                                label={option.label}
                                                labelPlacement="top"
                                                />
                                            ))}
                                            <Typography>Agree</Typography>
                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                                <Paper elevation={3} className={classes.paperRadioButtons}>
                                    <FormControl component="fieldset">
                                        <Typography className={classes.radioTypography}>The Company is aggressively executing the disposition process.</Typography>
                                        <RadioGroup row aria-label="aggressive" name="aggressive" onChange={handleChange('aggressive')} className={classes.radioGroup}>
                                            <Typography>Disagree</Typography>
                                            {radio_props_agree_disagree.map((option) => (
                                                <FormControlLabel
                                                value={option.value}
                                                control={<Radio color="primary" />}
                                                label={option.label}
                                                labelPlacement="top"
                                                />
                                            ))}
                                            <Typography>Agree</Typography>
                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                            </div>
                            <div className={classes.formContainerHorizontal}>
                                <Paper elevation={3} className={classes.paperRadioButtons}>
                                    <FormControl component="fieldset">
                                        <Typography className={classes.radioTypography}>The company uses NRV (net realizable value) models that assist in space strategy and financial decision making</Typography>
                                        <RadioGroup row aria-label="nrv" name="nrv" onChange={handleChange('nrv')} className={classes.radioGroup}>
                                            <Typography>Disagree</Typography>
                                            {radio_props_agree_disagree.map((option) => (
                                                <FormControlLabel
                                                value={option.value}
                                                control={<Radio color="primary" />}
                                                label={option.label}
                                                labelPlacement="top"
                                                />
                                            ))}
                                            <Typography>Agree</Typography>
                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                                <Paper elevation={3} className={classes.paperRadioButtons}>
                                    <FormControl component="fieldset">
                                        <Typography className={classes.radioTypography}>Does the Company's RE portfolio tie into the ERP system?</Typography>
                                        <RadioGroup row aria-label="erpSystem" name="erpSystem" onChange={handleChange('erpSystem')} className={classes.radioGroup}>
                                            {radio_props_yes_no.map((option) => (
                                                <FormControlLabel
                                                value={option.value}
                                                control={<Radio color="primary" />}
                                                label={option.label}
                                                labelPlacement="top"
                                                />
                                            ))}
                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                            </div>
                            <div className={classes.formContainerHorizontal}>
                                <Paper elevation={3} className={classes.paperRadioButtons}>
                                    <FormControl component="fieldset">
                                        <Typography className={classes.radioTypography}>The Company has the ability to breakout financials for RE occupancy costs.</Typography>
                                        <RadioGroup row aria-label="breakoutFinancials" name="breakoutFinancials" onChange={handleChange('breakoutFinancials')} className={classes.radioGroup}>
                                            {radio_props_yes_no.map((option) => (
                                                <FormControlLabel
                                                value={option.value}
                                                control={<Radio color="primary" />}
                                                label={option.label}
                                                labelPlacement="top"
                                                />
                                            ))}
                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                                <Paper elevation={3} className={classes.paperRadioButtons}>
                                    <FormControl component="fieldset">
                                        <Typography className={classes.radioTypography}>If the Company runs SAP or Oracle - Is the RE module currently activated?</Typography>
                                        <RadioGroup row aria-label="REModule" name="REModule" onChange={handleChange('REModule')} className={classes.radioGroup}>
                                            {radio_props_yes_no.map((option) => (
                                                <FormControlLabel
                                                value={option.value}
                                                control={<Radio color="primary" />}
                                                label={option.label}
                                                labelPlacement="top"
                                                />
                                            ))}
                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                            </div>
                            <div className={classes.formContainerHorizontal}>
                                <Paper elevation={3} className={classes.paperChallengesQuestion}>
                                    <Typography className={classes.radioTypography}>What are the barriers to optimizing real estate assets in your enterprise?</Typography>
                                    <FormControl>
                                        <TextField 
                                            id="standard-multiline-challenges" 
                                            label="Your Answer" 
                                            multiline rowsMax={4} 
                                            value={surveyForm.challenges} 
                                            onChange={handleChange('challenges')}
                                        />
                                    </FormControl>
                                </Paper>
                            </div>
                            <div className={classes.formButton}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="Large"
                                    disabled={
                                    surveyForm.email.length > 0 && surveyForm.name.length > 0 && surveyForm.company.length > 0 && surveyForm.industry.length > 0 
                                    && surveyForm.phone.length && surveyForm.mission.length > 0 && surveyForm.potential.length > 0 && surveyForm.bestPractices.length > 0 && surveyForm.kpi.length > 0
                                    && surveyForm.disposition.length > 0 && surveyForm.aggressive.length > 0 && surveyForm.nrv.length > 0 && surveyForm.erpSystem.length > 0
                                    && surveyForm.breakoutFinancials.length > 0 && surveyForm.REModule.length > 0 && surveyForm.challenges.length > 0 ? false : true
                                    }
                                    onClick={() => handleClick()}
                                >
                                    Submit
                                </Button>
                            </div>
                        </div>
                </div>
            </div>
        </Widget>
    </>
  );
}